import React from "react";

const PasswordRequirements = ({ passwordValidationRules }) => {
  return (
    <ul className="d-flex flex-column justify-content-between flex-grow-1 password-requirements pl-4">
      {passwordValidationRules.map((rule, key) => (
        <li key={key}>
          <i
            className={
              rule.validation
                ? "icon-omni-checkbox-true omni-color-ocean-green "
                : "icon-omni-cross-grey"
            }
          />
          {" " + rule.message}
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;
